import React, { useEffect, useState } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearDepartamento from "../elementos/complejos/FormCrearDepartamento";
import FormEditarDepartamento from "../elementos/complejos/FormEditarDepartamento";
import { fetchNegociosData, fetchDepartamentosData, } from '../../peticiones_API/PeticionesGestionPersonasDepartamentos';

const GestorDepartamento = ({ crear }) => {
  const [loading, setLoading] = useState(true);
  const [negocios, setNegocios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);

  useEffect(() => {
      const fetchData = async () => {
        try {
          if (departamentos.length === 0) {
        const departamentosResponse = await fetchDepartamentosData();
        setDepartamentos(departamentosResponse);
          }
          if (negocios.length === 0) {
        const negociosResponse = await fetchNegociosData();
        console.log(negociosResponse)
        setNegocios(negociosResponse);
          }
        } catch (error) {
          console.log("Ha habido un error:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);

    if (loading) {
      return <div>Cargando...</div>;
    }
    
  return (
    <>
      <ContenedorPrincipal formaform="true">
      {crear ?
        <FormCrearDepartamento departamentos={departamentos} negocios={negocios} />
        :
        <FormEditarDepartamento departamentos={departamentos} negocios={negocios} />
      }
      </ContenedorPrincipal>
    </>
  );
}

export default GestorDepartamento;